import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetBrand } from "../queries/brands";
import { ENTITY } from "../constants";

export const BrandBreadcrumb = ({ match }) => {
  // Entity
  const { BRAND } = ENTITY;

    const {
      data: brand,
      isLoading,
      isError,
      error,
    } = useGetBrand(match.params.brandId);
  
    if (isLoading) {
      //return <span>Loading...</span>;
      return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
    }
  
    if (isError && error instanceof NotFoundException) {
      return <span>Not found</span>;
    }
  
    if (brand) {
      return <span>{trimString(brand[BRAND.nameField], 20)}</span>;
    }
  
    return null;
  };